import { useTranslation as a } from "@ado/translation-library";
import { importTranslationMetaModules as s } from "./index2.js";
let n;
function o(t) {
  return n = Object.assign({}, t, {
    t: (r, i) => t.t(`@ado/base-application.${r}`, i)
  }), n;
}
function u() {
  const t = s(), e = a(t, !0);
  o(e);
}
function p() {
  if (n === void 0) {
    const t = a();
    return o(t);
  }
  return n;
}
function d(t) {
  switch (t) {
    case "M":
      return "_male";
    case "F":
      return "_female";
    case "N":
      return "_neutral";
    default:
      return "";
  }
}
export {
  d as getGenderContext,
  u as loadBaseApplicationTranslations,
  p as useBaseApplicationTranslation
};
//# sourceMappingURL=index.js.map
